import { useNavigate } from 'react-router-dom'
import { AlertTriangle, CheckCircle2, Info } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

/**
 * CON QUÉ CATÁLOGO QUEDÓ LA EMPRESA, a la vista en la ficha del cliente.
 *
 * Antes había que abrir la cotización para saber si el catálogo del contador había entrado, y ni
 * ahí se veía si quedó cerrado como su sistema contable autorizado o abierto (sin firma, sin
 * cuenta puente, incompleto). Solo se pinta si el cliente trae el suyo: con el estándar no hay
 * nada que vigilar.
 */
export default function EstadoCatalogoContador({ ficha }) {
  const navigate = useNavigate()
  const origen = ficha.propuestaOrigen
  const cat = origen?.catalogo
  if (!cat?.propio) return null
  const carga = cat.carga
  const irAlCatalogo = () => navigate(`/consultor/cotizaciones/${origen.id}?paso=4&seccion=catalogo-contador`)

  let tono = 'text-neutral-600 dark:text-neutral-400'
  let Icono = Info
  let texto = 'Todavía no está en la empresa: entra al crear la demo o al entregarla.'
  if (carga?.ok === false) {
    tono = 'text-danger-700 dark:text-danger-300'
    Icono = AlertTriangle
    texto = `No entró entero (${carga.error || carga.motivo || 'sin detalle'}). La empresa no se puede entregar hasta completarlo.`
  } else if (carga?.ok && carga.catalogoCerrado) {
    tono = 'text-success-700 dark:text-success-300'
    Icono = CheckCircle2
    texto = 'Está en la empresa y cerrado como su sistema contable autorizado.'
  } else if (carga?.ok) {
    tono = 'text-warning-700 dark:text-warning-300'
    Icono = AlertTriangle
    texto = `Está en la empresa, pero abierto: ${carga.avisoCierre || 'falta la firma del contador.'}`
  }

  return (
    <Card className="p-4 sm:p-5 space-y-2">
      <h3 className="font-semibold text-neutral-900 dark:text-neutral-50">Catálogo de cuentas del contador</h3>
      <p className={`flex items-start gap-2 text-body-sm ${tono}`}>
        <Icono size={15} className="mt-0.5 shrink-0" />
        <span>{texto}</span>
      </p>
      {carga?.avisoMapeo && (
        <p className="text-body-sm text-warning-700 dark:text-warning-300">
          Las cuentas clave no se guardaron en la empresa: {carga.avisoMapeo}
        </p>
      )}
      <Button variant="ghost" size="sm" onClick={irAlCatalogo}>
        Ver el catálogo en la cotización
      </Button>
    </Card>
  )
}
